import Auth from '@aws-amplify/auth';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { routes } from '@/app/routes';
import * as userActions from '@/user/user-actions';
import { LoadingPlaceholder } from '@/widgets/components/data-loading-placeholder';
import { CognitoLoginMgr } from '../cognito-login-manager/cognito-login-mgr';

export function LogoutPage() {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    async function checkAuthAndLogout() {
      try {
        // if user is signed in, signout
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const isSSOEmail = await CognitoLoginMgr.getInstance().isSSOEmail(
          cognitoUser.username
        );
        dispatch(userActions.userSignout());
        // SSO logout will do the redirect to root on its own. For normal logout, redirect here
        if (!isSSOEmail) {
          history.push(routes.ROOT);
        }
      } catch {
        // if user is already signed out, redirect to the root page
        history.push(routes.ROOT);
      }
    }
    checkAuthAndLogout();
  }, [history, dispatch]);

  return <LoadingPlaceholder loadingText="Logging out of Rentalscape" />;
}
